import * as Analytics from 'analytics';
import rudderstackPlugin from './rudderstack';

/* Initialize analytics & load plugins */
const analytics: any = Analytics.default({
  app: 'pinata_app',
  plugins: [
    rudderstackPlugin({
      writeKey: process.env.REACT_APP_ANALYTICS_WRITE_KEY || '',
      dataPlaneUrl: process.env.REACT_APP_DATA_PLANE_URL || '',
      customScriptSrc: "https://static.pinata.cloud/rudder_v1.min.js",
    })
  ]
});

export default analytics;
